import React, { useState } from 'react';
import { Stack, Tabs, Card, Text, Flex } from '@mantine/core';
import { DatePicker } from '@mantine/dates';
import TaskAccordion from './TaskAccordion';


const LeftPanel = ({ selectedDate, setSelectedDate, setIsLoading, breachData = [], onRefresh }) => {
    const [activeTab, setActiveTab] = useState('all');

    const handleDateChange = (date) => {
        setSelectedDate(date);
    };

    const handleTabChange = (value) => {
        setActiveTab(value);
    };

    return (
        <Flex gap="sm" style={{ width: '100%' }}>
            <Flex direction="column" gap="sm" style={{ minWidth: 280 }}>
                <Card withBorder radius="lg">
                    <Stack gap="sm">
                        <Text size="sm" fw={600} c="dimmed">
                            Filtros de Actividades
                        </Text>
                        <Tabs value={activeTab} onTabChange={handleTabChange} orientation="vertical" variant="pills">
                            <Tabs.List style={{width: '100%'}}>
                                <Tabs.Tab value="all">
                                    <Flex gap="xs" align="center">
                                        <i className='icon-layers'></i>
                                        Todo
                                    </Flex>
                                </Tabs.Tab>
                                <Tabs.Tab value="Pendiente">
                                    <Flex gap="xs" align="center">
                                        <i className='icon-clock'></i>
                                        Pendientes
                                    </Flex>
                                </Tabs.Tab>
                                <Tabs.Tab value="En revisión">
                                    <Flex gap="xs" align="center">
                                        <i className='icon-eye'></i>
                                        En revisión
                                    </Flex>
                                </Tabs.Tab>
                                <Tabs.Tab value="Aprobado">
                                    <Flex gap="xs" align="center">
                                        <i className='icon-thumbs-up'></i>
                                        Aprobados
                                    </Flex>
                                </Tabs.Tab>
                                <Tabs.Tab value="Rechazado">
                                    <Flex gap="xs" align="center">
                                        <i className='icon-thumbs-down'></i>
                                        Rechazados
                                    </Flex>
                                </Tabs.Tab>
                                <Tabs.Tab value="Expirado">
                                    <Flex gap="xs" align="center">
                                        <i className='icon-ban'></i>
                                        Expirados
                                    </Flex>
                                </Tabs.Tab>
                            </Tabs.List>
                        </Tabs>
                    </Stack>
                </Card>

                <Card withBorder radius="lg"> 
                    <Stack gap="sm">
                        <Text size="sm" fw={600} c="dimmed">
                            Fecha seleccionada
                        </Text>
                        <DatePicker
                            value={selectedDate}
                            onChange={handleDateChange}
                            size="sm"
                            variant="filled"
                            firstDayOfWeek={1} 
                            locale="es"
                        />
                    </Stack>
                </Card>
            </Flex>

            <Flex direction="column" style={{ flex: 1, width:"100%" }}>
                <TaskAccordion 
                    breachData={breachData}
                    filterType={activeTab}
                    selectedDate={selectedDate}
                    onRefresh={onRefresh}
                />
            </Flex>
        </Flex>
    );
};

export default LeftPanel;